import React, { useEffect } from 'react';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import taxi4 from '../../Images/taxi4.jpg';
import blog1 from '../../Images/Taj.webp';
import blog2 from '../../Images/videoImage.jpg';
import blog3 from '../../Images/taxi-booking.jpg';
import blog4 from '../../Images/contentImage.png';
import { Link } from 'react-router-dom';
import useSEO from '../../Hooks/UseSeo';

const blogs = [
  {
    id: 1,
    slug: 'top-must-visit-places-in-agra',
    date: 'November 12, 2025',
    author: 'Pick Quick cabs',
    comments: 'No Comments',
    title: 'Top Must-Visit Places in Agra: Explore the City of Wonders',
    desc: 'Explore the top must-visit places in Agra — from the Taj Mahal to bustling bazaars — and discover why booking Pick Quick Cabs makes your journey easier.',
    img: blog1
  },
  {
    id: 2,
    slug: 'top-must-visit-places-in-delhi',
    date: 'November 22, 2025',
    author: 'Jhonde Doe',
    comments: 'No Comments',
    title: 'Top Must-Visit Places in Delhi Using Pick Quick Cabs Taxi Service',
    desc: 'Discover smart travel hacks and affordable cab services to make your next long-distance trip budget-friendly and comfortable.',
    img: blog2
  },
  {
    id: 3,
    slug: 'best-weekend-road-trips-from-delhi-to-shimla',
    date: 'December 16 , 2025',
    author: 'Jhonde Doe',
    comments: 'No Comments',
    title: 'Best Weekend Road Trips from Delhi to Shimla in 2026',
    desc: 'Find out why Pick Quick Cabs is the top choice for business and airport travel with reliable, comfortable, and safe cab services.',
    img: blog3
  },
  {
    id: 4,
    slug: 'local-cab-deals',
    date: 'November 12, 2025',
    author: 'Jhonde Doe',
    comments: 'No Comments',
    title: 'Learn how to get long distance travel in cheap rates',
    desc: 'Travel smart with the best cab deals and offers in your city with Pick Quick Cabs.',
    img: blog4
  }
];

export default function BlogGrid() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useSEO({
    title: 'Our Blogs | Pick Quick Cabs',
    description: 'Read Our Latest Blogs on our website',
    url: 'https://www.pickquickcabs.com/blog'
  });

  return (
    <>
      <Header />
      <div
        className="relative mt-32 h-[50vh] sm:h-[60vh] md:h-[90vh] flex items-center justify-center text-center text-white px-4"
        style={{
          backgroundImage: `url(${taxi4})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="max-w-3xl">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold drop-shadow-lg">
            Blog
          </h1>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          {blogs.map((blog) => (
            <div
              key={blog.id}
              className="shadow-lg rounded-lg overflow-hidden flex flex-col"
            >
              <img
                src={blog.img}
                alt={blog.title}
                className="w-full h-64 sm:h-72 md:h-80 object-cover"
              />
              <div className="p-6 flex flex-col flex-1">
                <span className="bg-yellow-400 text-black text-xs font-bold px-3 py-1 rounded">
                  {blog.date}
                </span>
                <p className="text-gray-600 text-sm mt-2">
                  by {blog.author} • {blog.comments}
                </p>
                <Link to={`/blog/${blog.slug}`}>
                  <h2 className="text-lg sm:text-xl font-bold mt-3 hover:text-yellow-400 cursor-pointer">
                    {blog.title}
                  </h2>
                </Link>
                <p className="text-gray-500 text-sm mt-2 flex-1">{blog.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
}
